import { SheetEventModel } from '@modules/sheet-event/sheet-event-model';

const { fields } = SheetEventModel;

export default [
  fields.id,
  fields.type,
  fields.subtypeGame,
  fields.subtypeGoal,
  fields.subtypeCard,
  fields.subtypePenaltyShootout,
  fields.teamId,
  fields.minute,
  fields.player,
  fields.otherTeamId,
  fields.createdAt
];
